import { HIDE_THIRD_PARTY_WIDGET } from 'calling-global-api/constants/EventListeners';
export function triggerHostMessageHideThirdPartyWidget(data) {
  if (window.hsCalling.triggerEvent) {
    window.hsCalling.triggerEvent({
      event: HIDE_THIRD_PARTY_WIDGET,
      data
    });
  }
}